
import Vue, { PropType } from 'vue';
import Api from '@/core/api';
import { Question } from './Qna.vue';
import { get } from 'lodash';
import LikeButton from '@/common/like-button/LikeButton.vue';
import Profile from '@/common/profile/Profile.vue';
import { Theme } from '@/side-bar/side-bar-config.interface';

export default Vue.extend({
    name: 'Question',

    components: {
        LikeButton,
        Profile
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        question: {
            type: Object as PropType<Question>,
            required: true,
        },
        showHighlighted: {
            type: Boolean,
            default: false
        },
        theme: {
            type: Object as PropType<Theme>,
            default: () => ({})
        },
        upvotingEnabled: {
            type: Boolean,
            default: false
        },
        upvotingAllowed: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        subtitle():string {
            return this.question.sent || '';
        },
        questionStyles():Record<string, string> {
            if (this.isHighlighted) {
                return {};
            }
            return get(this, 'question.styles', {});
        },
        isHighlighted():boolean {
            return this.question.status === 'highlighted' && this.showHighlighted;
        },

        showUserInitials():boolean {
            return get(this, 'question.showUserInitials', true);
        }
    },

    methods: {
        onProfileClick() {
            this.api.customAction({ pid: this.question.userId }, 'questionCLicked');
        },
        onLikeButtonClick() {
            const action = this.question.upvoted ? 'removeQuestionUpvote' : 'addQuestionUpvote';
            this.api.customAction(this.question, action);
        }
    }
});
